<template>
  <div class="template-footer-one enhanced-footer pt-100 with-top-border">
    <div class="container">
      <div class="row justify-content-center">
        <!-- Company Info -->
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget">
            <router-link to="/" class="logo">
              <img src="../../assets/images/logo.png" alt="Fontes Business">
            </router-link>
            <p>Fábrica de software e desenvolvimento de projetos sob medida. Soluções digitais, ERPs e sistemas verticais para levar sua empresa ao próximo nível.</p>

            <div class="location-info">
              <i class="ph-map-pin"></i>
              <span>Canela - Rio Grande do Sul, Brasil</span>
            </div>

            <div class="certifications">
              <div class="cert-badge">
                <i class="ph-shield-check"></i>
                <span>ISO 27001</span>
              </div>
              <div class="cert-badge">
                <i class="ph-lightning"></i>
                <span>Ágil Certified</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="col-lg-2 col-md-6">
          <div class="single-footer-widget">
            <h3>Navegação</h3>
            <ul class="quick-links">
              <li><router-link to="/"><i class="ph-caret-right"></i>Home</router-link></li>
              <li><router-link to="/about-us"><i class="ph-caret-right"></i>Sobre</router-link></li>
              <li><router-link to="/services"><i class="ph-caret-right"></i>Serviços</router-link></li>
              <li><router-link to="/contact"><i class="ph-caret-right"></i>Contato</router-link></li>
            </ul>
          </div>
        </div>

        <!-- Products -->
        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <h3>Nossos Produtos</h3>
            <ul class="quick-links">
              <li><router-link to="/fontes-business-one"><i class="ph-caret-right"></i>One</router-link></li>
              <li><router-link to="/erp-escolar"><i class="ph-caret-right"></i>Escola</router-link></li>
              <li><router-link to="/nutraxis"><i class="ph-caret-right"></i>Nutricionistas</router-link></li>
              <li><router-link to="/pila"><i class="ph-caret-right"></i>Pila</router-link></li>
              <li>
                <a
                  href="https://wa.me/5554992302401?text=Quero desenvolver um projeto sob medida"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="ph-caret-right"></i>Projetos sob medida
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Contact -->
        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <h3>Fale Conosco</h3>
            <ul class="contact-box">
              <li>
                <a href="https://wa.me/5554992302401" target="_blank" class="whatsapp-link" rel="noopener noreferrer">
                  <i class="flaticon-whatsapp"></i>
                  <div>
                    <strong>WhatsApp</strong>
                    <span>+55 (54) 99230-2401</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:contato@fontes.business">
                  <i class="ph-envelope-simple"></i>
                  <div>
                    <strong>E-mail</strong>
                    <span>contato@fontes.business</span>
                  </div>
                </a>
              </li>
            </ul>

            <div class="business-hours">
              <i class="ph-clock"></i>
              <div>
                <strong>Horário</strong>
                <span>24h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright-area">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <p>
              © {{ currentYear }} <strong>Fontes Business</strong>. Todos os direitos reservados.
              CNPJ 30.580.155/0001-05.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  }
}
</script>

<style scoped>
.enhanced-footer {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #e0e0e0;
}

.single-footer-widget .logo {
  display: inline-block;
  margin-bottom: 20px;
}

.single-footer-widget .logo img {
  max-height: 36px;
  width: auto;
  filter: brightness(0) invert(1);
}

.single-footer-widget p {
  color: #b0b0b0;
  line-height: 1.8;
  margin-bottom: 20px;
}

.location-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e0e0e0;
  margin-bottom: 20px;
}

.location-info i {
  font-size: 20px;
  color: #6D5DFC;
}

.certifications {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.cert-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.3);
  border-radius: 20px;
  font-size: 12px;
  color: #6D5DFC;
  font-weight: 600;
}

.cert-badge i {
  font-size: 16px;
}

.single-footer-widget h3 {
  color: white;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 10px;
}

.single-footer-widget h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #6D5DFC 0%, #4361EE 100%);
}

.quick-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-links li {
  margin-bottom: 12px;
}

.quick-links a {
  color: #b0b0b0;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-size: 15px;
}

.quick-links a:hover {
  color: #6D5DFC;
  transform: translateX(5px);
}

.quick-links a i {
  font-size: 12px;
  color: #6D5DFC;
}

.contact-box {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-box li {
  margin-bottom: 20px;
}

.contact-box a {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #e0e0e0;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 8px;
}

.contact-box a:hover {
  background: rgba(109, 93, 252, 0.1);
  transform: translateX(5px);
}

.contact-box a i {
  font-size: 24px;
  color: #6D5DFC;
  min-width: 30px;
}

.contact-box a.whatsapp-link i {
  color: #25D366;
}

.contact-box a div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-box strong {
  color: white;
  font-size: 14px;
}

.contact-box span {
  color: #b0b0b0;
  font-size: 13px;
}

.business-hours {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: rgba(109, 93, 252, 0.05);
  border-radius: 8px;
  margin-top: 20px;
}

.business-hours i {
  font-size: 24px;
  color: #6D5DFC;
}

.business-hours div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.business-hours strong {
  color: white;
  font-size: 14px;
}

.business-hours span {
  color: #b0b0b0;
  font-size: 13px;
}

.copyright-area {
  margin-top: 60px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright-area p {
  color: #b0b0b0;
  margin: 0;
  text-align: center;
}

.copyright-area strong {
  color: white;
  font-weight: 600;
}

@media (max-width: 991px) {
  .single-footer-widget {
    margin-bottom: 40px;
  }

  .copyright-area {
    text-align: center;
  }
}
</style>
